module.exports = __webpack_public_path__ + "img/low-do-alert-v2.169aed3f.svg";